import React from 'react';
import { Row, Col, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import type { SubHeaderProps } from './types';
import './subHeader.scss';

const SubHeader = (props:SubHeaderProps) => {
    const {
        hasBackLink,
        backLinkCallback,
        backLink,
        leftAction,
        rightAction,
        title,
        useCloseIcon,
    } = props;

    const backIcon = useCloseIcon ? (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M13 1.5L1 13.5M1 1.5L13 13.5" stroke="#2B2D42" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ) : <LeftOutlined />;

    return (
        <div className="sub-header">
            <Row>
                <Col className="left" xs={8} sm={8} md={8} lg={8} xl={8}>
                    {hasBackLink ? (
                        <Button href={backLink} type="link" onClick={backLinkCallback}>
                            {backIcon}
                        </Button>
                    ) : leftAction}
                </Col>
                <Col className="middle" xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="title-text">
                        {title}
                    </div>
                </Col>
                <Col className="right" xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div>{rightAction}</div>
                </Col>
            </Row>
        </div>
    );
};

SubHeader.defaultProps = {
    hasBackLink: false,
    useCloseIcon: false,
    leftAction: '',
    rightAction: '',
    title: '',
    backLinkCallback: () => console.log('Back'),
    backLink: '#',
};

export default SubHeader;
